import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { RenderField, RenderSubmitButton, RenderDropdownSelect } from '../../common/form';
import { updateShippingAddress, updateRegistryPublish } from '../../../actions/RegistryActions';
import * as Validations from '../../common/form/commonValidations';
import * as AddressData from '../../common/form/CountryCodes';
import { showModal } from '../../../actions/ModalActions';

class SetShippingAddressFormv2 extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onOverride = this.onOverride.bind(this);
    this.handleError = this.handleError.bind(this);

    this.state = {
      hasError: false,
      errorMessage: '',
      allowBypass: false,
    };
  }

  onSubmit(values) {
    const { onUpdateShippingAddress, onSuccess } = this.props;
    return onUpdateShippingAddress(values, true)
      .then(() => onSuccess())
      .catch(err => err.response.json().then(json => this.handleError(json)));
  }

  onOverride(values) {
    const { onUpdateShippingAddress, onSuccess } = this.props;
    return onUpdateShippingAddress(values, false)
      .then(() => onSuccess())
      .catch(err => err.response.json().then(json => this.handleError(json)));
  }

  handleError(err) {
    const { errorMessage, errorData } = err;
    this.setState({ hasError: true, errorMessage, allowBypass: errorData.allowBypass });
  }

  render() {
    const { pristine, valid, submitting, handleSubmit } = this.props;
    const { submitButtonText, submitButtonClassName, submitButtonAction } = this.props;
    const { secondaryButtonText, secondaryButtonAction, secondaryButtonClassName } = this.props;
    const { hasError, errorMessage, allowBypass } = this.state;
    return (
      <div className="shipping-address-form-v2">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          {hasError && (
            <div className="row shipping-address-error">
              <div className="col-xs-12">
                <div className="alert alert-danger text-center">
                  {errorMessage}<br />
                  {allowBypass && (
                    <span>If you&#39;re sure this is correct, <a role="button" onClick={handleSubmit(this.onOverride)} className="alert-link set-address-override">click here to save your changes</a></span>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="shipping-field-container">
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <Field
                  name="first_name"
                  label="First Name"
                  id="shipping_address_first_name"
                  type="text"
                  component={RenderField}
                  required
                  validate={Validations.REQUIRED}
                />
              </div>
              <div className="col-xs-12 col-sm-8">
                <Field
                  name="last_name"
                  label="Last Name"
                  id="shipping_address_last_name"
                  type="text"
                  component={RenderField}
                  required
                  validate={Validations.REQUIRED}
                />
              </div>
            </div>
            <div className="shipping-address">
              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <Field
                    name="street_line_1"
                    label="Street Address"
                    type="text"
                    id="address-street-1"
                    component={RenderField}
                    required
                    validate={Validations.REQUIRED}
                  />
                </div>
                <div className="col-xs-12 col-sm-4">
                  <Field
                    name="street_line_2"
                    label="Apt / Floor"
                    type="text"
                    id="address-street-2"
                    component={RenderField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <Field
                    name="city"
                    label="City"
                    type="text"
                    id="address-city"
                    component={RenderField}
                    required
                    validate={Validations.REQUIRED}
                  />
                </div>
                <div className="col-xs-12 col-sm-4">
                  <Field
                    name="state_province_region"
                    label="State"
                    options={AddressData.UnitedStates}
                    id="address-state"
                    component={RenderDropdownSelect}
                    required
                    validate={Validations.REQUIRED}
                  />
                </div>
                <div className="col-xs-12 col-sm-4">
                  <Field
                    name="postal_code"
                    label="Zip Code"
                    type="text"
                    id="address-postal-code"
                    component={RenderField}
                    required
                    validate={[Validations.REQUIRED, Validations.ZIP]}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <Field
                  className="phone-number-field"
                  name="phone_number"
                  label="Phone Number"
                  type="tel"
                  id="address-phone-number"
                  component={RenderField}
                  required
                  validate={[Validations.REQUIRED, Validations.PHONE]}
                  placeholder="(   ) ___-____"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="wrapping-button-container shipping-address-form-buttons product-actions">
              {secondaryButtonText && (
                <a role="button" onClick={secondaryButtonAction}>
                  <button type="button" className={`v2-button secondary-button ${secondaryButtonClassName || ''}`}>{secondaryButtonText}</button>
                </a>
              )}
              {submitButtonText ? (
                <RenderSubmitButton pristine={pristine} disabled={submitting || !valid} valid={valid} className={`${submitButtonClassName || ''}`} value={submitButtonText} onClick={event => submitButtonAction(event)} target="_self" />
              )
                : <RenderSubmitButton pristine={pristine} disabled={submitting} valid={valid || true} className="set-shipping-continue" value={submitButtonText} />
              }
            </div>
          </div>
        </form>
      </div>
    );
  }
}

SetShippingAddressFormv2.propTypes = {
  pristine: PropTypes.bool,
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onSuccess: PropTypes.func,
  onUpdateShippingAddress: PropTypes.func,
  submitButtonText: PropTypes.string,
  submitButtonAction: PropTypes.func,
  submitButtonClassName: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  secondaryButtonClassName: PropTypes.string,
};

function mapAddressDataToForm(addressData) {
  if (!addressData || !addressData.street_address_1) {
    return null;
  }
  // eslint-disable-next-line camelcase
  const { street_address_1, street_address_2 } = addressData;
  return Object.assign({}, addressData, { street_line_1: street_address_1, street_line_2: street_address_2 });
}

const mapStateToProps = state => ({
  initialValues: mapAddressDataToForm(state.registry.address_view)
});

const mapDispatchToProps = dispatch => ({
  onUpdateShippingAddress: (address, validate) => dispatch(updateShippingAddress(address, validate)),
  showSuccessModal: () => dispatch(showModal('PUBLISH_REGISTRY')),
  publishRegistry: () => dispatch(updateRegistryPublish(true)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'setShippingAddress',
})(SetShippingAddressFormv2));



// WEBPACK FOOTER //
// ./src/components/manage/common/SetShippingAddressFormv2.jsx